import { bl_inv_opdg_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class InventoryOpdgHdrContainer extends BaseContainerModel {
  bl_inv_opdg_hdr: bl_inv_opdg_hdr_RowClass = new bl_inv_opdg_hdr_RowClass();
}
